import React, { Fragment } from 'react';

const LocationService = ({ city = 'toronto' }) => (
  <Fragment>
    <p>
      For you to have the best driving experience using our app, you will
      need to enable your location services. This will allow you access to
      our Autzu vehicles.
    </p>
    <ol>
      <li>Open your phone Settings and search for the Autzu App.</li>
      <li>
        After you have selected Autzu, allow Autzu to{' '}
        <strong>Always</strong> access your notifications (turn on) and
        make sure that cellular data/location services are turned on.
      </li>
    </ol>
  </Fragment>
);

export default LocationService;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/SignUp/LocationService.js